export default __webpack_public_path__ + "static/media/icon-modal_x.9840ff38.svg";